import { configureStore } from '@reduxjs/toolkit';
import { persistReducer, persistStore } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import thunk from 'redux-thunk';
import { rootReducer } from './reducers';

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['vaultLock', 'onboarding'], // Persist vaultLock and onboarding state
  debug: true, // Enable debug mode
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
      },
    }).concat(thunk),
  devTools: true,
});

// Log initial state

// Subscribe to state changes
// store.subscribe(() => {
//   console.debug('Redux State Updated:', store.getState());
// });

export const persistor = persistStore(store);

export function clearPersistedState() {
  persistor.purge();
}

function scheduleMidnightClearPersistedState() {
  const now: Date = new Date();
  const midnight: Date = new Date(
    now.getFullYear(),
    now.getMonth(),
    now.getDate() + 1,
    0, // Hour
    0, // Minute
    0, // Second
  );

  const timeUntilMidnight = midnight.getTime() - now.getTime();

  setTimeout(() => {
    clearPersistedState();
    sessionStorage.clear();
    scheduleMidnightClearPersistedState(); // Schedule the next midnight clear
  }, timeUntilMidnight);
}

scheduleMidnightClearPersistedState();

// clearPersistedState();

export type AppDispatch = typeof store.dispatch;
export default store;
